import React from "react";
import { Form, Col, Container, Row } from "react-bootstrap";

const actionOptions = [
  { value: "", label: "-- Wszystkie --" },
  { value: "1", label: "Błąd" },
  { value: "2", label: "Ostrzeżenie" },
  { value: "3", label: "Informacja" },
];

const AuditLogFilters = ({ onFilterChange, onSearch, onImmediateFilterChange, filters = {} }) => {
  return (
    <Container className="mt-4">
      <Form onKeyDown={(e) => { if (e.key === 'Enter' && !['TEXTAREA', 'SELECT'].includes(e.target.tagName)) { e.preventDefault(); onSearch?.(); } }}>
        <Row className="mb-3">
          <Col md={2}>
            <Form.Group controlId="dateFrom">
              <Form.Label>Data od</Form.Label>
              <Form.Control
                type="date"
                value={filters.dateFrom || ""}
                onChange={(e) => onFilterChange("dateFrom", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group controlId="dateTo">
              <Form.Label>Data do</Form.Label>
              <Form.Control
                type="date"
                value={filters.dateTo || ""}
                onChange={(e) => onFilterChange("dateTo", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group controlId="action">
              <Form.Label>Akcja</Form.Label>
              <Form.Select
                value={filters.action ?? ""}
                onChange={(e) => (onImmediateFilterChange || onFilterChange)("action", e.target.value)}
              >
                {actionOptions.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group controlId="userLogin">
              <Form.Label>Użytkownik</Form.Label>
              <Form.Control
                type="text"
                placeholder="Login..."
                value={filters.userLogin || ""}
                onChange={(e) => onFilterChange("userLogin", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group controlId="query">
              <Form.Label>Szukaj</Form.Label>
              <Form.Control
                type="text"
                placeholder="Szukaj w opisie..."
                value={filters.query || ""}
                onChange={(e) => onFilterChange("query", e.target.value)}
              />
            </Form.Group>
          </Col>
        </Row>
      </Form>
    </Container>
  );
};

export default AuditLogFilters;
